export const blockIconsUiactionsDownloadNew = (
	<span className='material-symbols-outlined'>download</span>
);
